import { IFormDefinition } from '../Definitions/IFormDefinition';
import { convertBinds } from './BindConverter';
import { convertInstances } from './InstanceConverter';
import { createXPathEvaluator } from '../XPath/XPathEvaluator';
import { action } from 'mobx';
import { convertBuildingBlock } from './BuildingBlockConverter';
import { convertPages } from './PageConverter';
import Form from '../Components/Form';
import PersistenceHandler from '../Persistence/PersistenceHandler';
import { composeSubmission } from '../Persistence/SubmissionComposer';
import { SubmissionService, defaultSubmissionService } from '../Persistence/SubmissionService';
import SuccessActionResolver from '../Persistence/SuccessActionResolver';
import NavigateParams from '../Persistence/NavigateParams';

export const convertForm = action(
  (
    formDefinition: IFormDefinition,
    submissionService: SubmissionService = defaultSubmissionService
  ) => {
    const instanceStore = convertInstances(formDefinition);
    const xPathEvaluator = createXPathEvaluator(instanceStore.resolve);

    const bindStore = convertBinds(instanceStore, xPathEvaluator, formDefinition.buildingBlocks);

    const buildingBlocks = convertBuildingBlock(
      instanceStore,
      bindStore,
      formDefinition.buildingBlocks
    );
    const pages = convertPages(buildingBlocks, formDefinition.pages);

    const form = new Form(
      formDefinition.title,
      formDefinition.warningCode,
      formDefinition.viewMode,
      pages,
      formDefinition
    );

    const persistenceHandler = new PersistenceHandler(
      formDefinition.persistence,
      {
        validate: form.validate,
        updatedSinceLastAutosave: () => form.updatedSinceLastAutosave,
        markControlsAsNotUpdated: form.markControlsAsNotUpdated,
      },
      (recaptchaToken?: string) =>
        composeSubmission(formDefinition.buildingBlocks, instanceStore, recaptchaToken),
      submissionService,
      new SuccessActionResolver(
        formDefinition.successAction,
        new NavigateParams(window.location.search),
        (xpath: string) => xPathEvaluator.evaluateXPathToBoolean(xpath)
      )
    );

    return {
      form,
      instanceStore,
      persistenceHandler,
    };
  }
);
